import { useEffect } from "react";

const SITE = "https://thesealcollective.com";
const HOME_TITLE = "The SEAL Collective | Voice, Consciousness, Creativity & Human Transformation";
const HOME_DESC =
  "The SEAL Collective brings together voice, sound, consciousness, creativity, technology, leadership, and human-centered transformation through the work of Amber Ellis.";

const setTag = (selector, attr, value, attrName = "content") => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    setTag('meta[name="description"]', "content", description);
    setTag('link[rel="canonical"]', "href", url, "href");
    setTag('meta[property="og:title"]', "content", title);
    setTag('meta[property="og:description"]', "content", description);
    setTag('meta[property="og:url"]', "content", url);
    setTag('meta[name="twitter:title"]', "content", title);
    setTag('meta[name="twitter:description"]', "content", description);
    return () => {
      document.title = HOME_TITLE;
      setTag('meta[name="description"]', "content", HOME_DESC);
      setTag('link[rel="canonical"]', "href", `${SITE}/`, "href");
      setTag('meta[property="og:title"]', "content", "The SEAL Collective");
      setTag('meta[property="og:description"]', "content", HOME_DESC);
      setTag('meta[property="og:url"]', "content", `${SITE}/`);
      setTag('meta[name="twitter:title"]', "content", "The SEAL Collective");
      setTag('meta[name="twitter:description"]', "content", HOME_DESC);
    };
  }, [title, description, path]);
  return null;
};

export default Seo;
